// extracted by mini-css-extract-plugin
export default {"popup":"EmailChangePopup__popup--19F","header":"EmailChangePopup__header--27f","inner":"EmailChangePopup__inner--3ug"};